/* Associations search filters reducer */

import * as _ from 'lodash';

import * as Actions from '../actions';

export interface ISearchFiltersClientDashboardState {
    keyword: string;
}

const initialState: ISearchFiltersClientDashboardState = {
    keyword: '',
};

export function searchFiltersClientDashboardReducer(state: ISearchFiltersClientDashboardState = initialState, action: any): ISearchFiltersClientDashboardState {
    switch (action.type) {
        case Actions.SEARCH_CLIENT_DASHBOARD_KEYWORD:
            return _.merge({}, state, { keyword: action.keyword });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/searchFiltersClientDashboardReducer.tsx